<template>
  <div v-if="value && value.length" class="slider-range">
    <h4 v-if="label" class="slider-range__label">{{label}}</h4>
    <div class="slider-range__main">
      <div v-if="value.length > 1"
           class="slider-range__input-wrap  _form">
        <div v-if="fromName" class="slider-range__input-name">{{fromName}}</div>
        <BaseInput :value="formatter(value[0])"
                   :type="type"
                   :leftSpace="getSpaceByText(fromName)"
                   @change="onFromInput"
                   class="slider-range__input"/>
      </div>
      <div v-else
           class="slider-range__input-wrap  _fixed">
        <div v-if="fromName" class="slider-range__input-name">{{fromName}}</div>
        <BaseInput :value="formatter(value[0])"
                   :type="type"
                   :leftSpace="getSpaceByText(fromName)"
                   @change="onFixedInput"
                   class="slider-range__input"/>
      </div>
      <VueSlider v-bind="$attrs"
                 :value="computedValue"
                 :min="min"
                 :max="max"
                 :interval="interval"
                 :enableCross="false"
                 :dotSize="['22', '22']"
                 height="0.8rem"
                 tooltip="none"
                 :contained="true"
                 @change="onSlideInput"
                 :class="value.length === 1 ? '_single' : null"
                 class="slider-range__slider"/>
      <div v-if="value.length > 1"
           class="slider-range__input-wrap  _to">
        <div v-if="toName" class="slider-range__input-name">{{toName}}</div>
        <BaseInput v-if="value.length > 1"
                   :leftSpace="getSpaceByText(toName)"
                   :value="formatter(value[1])"
                   :type="type"
                   @change="onToInput"
                   class="slider-range__input"/>
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-slider-component/theme/default.css'
  import VueSlider from 'vue-slider-component'

  export default {
    components: {
      VueSlider
    },
    props: {
      value: {
        type: [Array]
      },
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 100
      },
      interval: {
        type: Number,
        default: 0.01
      },
      label: String,
      fromName: String,
      toName: String,
      formatter: {
        type: Function,
        default: (v) => v
      },
      reverseFormatter: {
        type: Function,
        default: (v) => v
      },
      type: {
        type: String,
        default: 'number'
      }
    },
    data() {
      return {}
    },
    computed: {
      computedValue() {
        return [...this.value]
      }
    },
    methods: {
      onFromInput(inputValue) {
        inputValue = parseFloat(this.reverseFormatter(inputValue)) || 0
        if (inputValue > this.value[1]) inputValue = this.value[1] - 1
        if (inputValue < this.salaryMin) inputValue = this.salaryMin

        const newValue = [...this.value]
        newValue[0] = inputValue
        this.$emit('input', newValue)
      },
      onToInput(inputValue) {
        inputValue = parseFloat(this.reverseFormatter(inputValue)) || 0
        if (inputValue < this.value[0]) inputValue = this.value[0] + 1
        if (inputValue > this.salaryMax) inputValue = this.salaryMax

        const newValue = [...this.value]
        newValue[1] = inputValue
        this.$emit('input', newValue)
      },
      onFixedInput(inputValue) {
        inputValue = parseFloat(this.reverseFormatter(inputValue)) || 0
        if (inputValue < this.min) inputValue = this.min
        if (inputValue > this.max) inputValue = this.max

        this.$emit('input', [inputValue])
      },
      onSlideInput(value) {
        this.$emit('input', Array.isArray(value) ? value : [value])
      },
      getSpaceByText(text) {
        if(typeof text !== 'string') return
        return text.length * 0.7
      }
    }
  }
</script>

<style lang="less">

</style>
